const DIRECT_ORDER = 'directOrder';
const DIRECT_ORDER_RECURRING = 'directOrderRecurring';
const DISTRIBUTION = 'mrDistribution';
const COLLECTION = 'mrCollection';
const SINGLE_SHIPMENT = DIRECT_ORDER;

const TYPE_PRICE_DIRECT = 'DIRECT';
const INTERNAL_TYPE_PRICE_TODAY = 'TODAY';

const SERVICE_TYPE_ONTRUCK24 = 'ONTRUCK24';
const SERVICE_TYPE_LH_EXPRESS = 'LH_EXPRESS';

const ORDER_TYPE_SINGLE_SHIPMENT = 'SINGLE_SHIPMENT';
const ORDER_TYPE_COLLECTION = 'COLLECTION';
const ORDER_TYPE_DISTRIBUTION = 'DISTRIBUTION';

const TYPES = {
  DIRECT_ORDER,
  DIRECT_ORDER_RECURRING,
  DISTRIBUTION,
  COLLECTION,
  SINGLE_SHIPMENT,
};

export const ORDER_TYPES = {
  SINGLE_SHIPMENT: ORDER_TYPE_SINGLE_SHIPMENT,
  COLLECTION: ORDER_TYPE_COLLECTION,
  DISTRIBUTION: ORDER_TYPE_DISTRIBUTION,
};

export const MR_ORDER_TYPES = [
  ORDER_TYPES.COLLECTION,
  ORDER_TYPES.DISTRIBUTION,
];

const COUNTRIES_WITH_SPECIAL_PRICES = {
  ES: true,
  NL: true,
  FR: true,
  UK: false,
};

const APPOINTMENTS_ENABLED = {
  stopType: {
    pickup: false,
    dropoff: true,
  },
  orderType: {
    [DIRECT_ORDER]: false,
    [DIRECT_ORDER_RECURRING]: false,
    [COLLECTION]: false,
    [DISTRIBUTION]: false,
  },
};

const PRICE_TYPES = {
  [DIRECT_ORDER]: TYPE_PRICE_DIRECT,
  [DISTRIBUTION]: TYPE_PRICE_DIRECT,
  [COLLECTION]: TYPE_PRICE_DIRECT,
  [SINGLE_SHIPMENT]: TYPE_PRICE_DIRECT,
};

const getTypeForEvent = (typeOfOrder) => {
  const types = {
    directOrder: 'direct',
    mrDistribution: 'mr-d',
    mrCollection: 'mr-c',
    directOrderRecurring: 'recurring',
    service24hOrder: '24h',
  };

  return types[typeOfOrder] || typeOfOrder;
};

const URGENCY_TYPES = ['URGENT', 'SAME_DAY', 'NORMAL'];

const DEFAULT_VALIDATIONS = {
  max_weight_per_item: 1000,
  max_height: 220,
  max_length: 220,
  max_width: 220,
  max_items: 8,
  max_working_day: ['7:00', '18:00'],
  origin_max_working_day: ['7:00', '18:00'],
  destination_max_working_day: ['7:00', '18:00'],
  inclusive_working_day_difference: 14,
  creation_limit: '14:00',
  permitted_dates: [],
  permitted_pickup_dates: [],
  permitted_dropoff_dates: [],
};

export const ORDER_STATUSES = {
  PENDING_MODERATION: 'PENDING_MODERATION',
  PENDING_ASSIGNMENT: 'PENDING_ASSIGNMENT',
  PENDING_CONFIRMATION: 'PENDING_CONFIRMATION',
  PENDING_PAYMENT: 'PENDING_PAYMENT',
  ASSIGNED: 'ASSIGNED',
  IN_TRANSIT: 'IN_TRANSIT',
  DONE: 'DONE',
  DONE_WITHOUT_MANIFEST: 'DONE_WITHOUT_MANIFEST',
  DONE_WITH_CANCELLATIONS: 'DONE_WITH_CANCELLATIONS',
  CANCELLED: 'CANCELLED',
  NON_CORE_PENDING_CONFIRMATION: 'NON_CORE_PENDING_CONFIRMATION',
};

export const DONE_STATUSES = [
  ORDER_STATUSES.DONE,
  ORDER_STATUSES.DONE_WITHOUT_MANIFEST,
  ORDER_STATUSES.CANCELLED,
];

export const FINISHED_STATUSES = [
  ORDER_STATUSES.DONE,
  ORDER_STATUSES.DONE_WITHOUT_MANIFEST,
];

export const CANCELLABLE_BY_SHIPPER_STATUSES = [
  ORDER_STATUSES.PENDING_CONFIRMATION,
  ORDER_STATUSES.PENDING_MODERATION,
  ORDER_STATUSES.PENDING_ASSIGNMENT,
  ORDER_STATUSES.PENDING_PAYMENT,
];

export const STATUS_WHERE_USER_CAN_ADD_DOCUMENTS = [
  ORDER_STATUSES.PENDING_CONFIRMATION,
  ORDER_STATUSES.PENDING_MODERATION,
  ORDER_STATUSES.PENDING_ASSIGNMENT,
  ORDER_STATUSES.PENDING_PAYMENT,
  ORDER_STATUSES.ASSIGNED,
];

export default {
  TYPES,
  DIRECT_ORDER,
  DIRECT_ORDER_RECURRING,
  DISTRIBUTION,
  COLLECTION,
  getTypeForEvent,
  TYPE_PRICE_DIRECT,
  INTERNAL_TYPE_PRICE_TODAY,
  URGENCY_TYPES,
  COUNTRIES_WITH_SPECIAL_PRICES,
  PRICE_TYPES,
  DEFAULT_VALIDATIONS,
  SERVICE_TYPE_ONTRUCK24,
  SERVICE_TYPE_LH_EXPRESS,
  APPOINTMENTS_ENABLED,
};
